import { DECISION_USER } from 'business/constants';
import { useIsEssential, useIsExploreUser, useUserHasRole } from 'hooks/client';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import ModuleWithCallToAction from './CallToActions/ModuleWithCallToAction';
import ModuleForbidden from './RolesCheck/ModuleForbidden';
import routes from 'components/App/components/routes';

type Props = {
    isSupportUser: boolean;
    isAdminUser: boolean;
    hasDecision: boolean;
    children: React.ReactNode;
};

type RouteParams = {
    chartKey?: string;
};

const ExploreWithAccessCheck: React.FC<Props> = ({
    isSupportUser,
    isAdminUser,
    hasDecision,
    children,
}) => {
    const { t } = useTranslation();
    const isExploreUser = useIsExploreUser();
    const isDecisionUser = useUserHasRole(DECISION_USER);
    let allowed = isExploreUser && isDecisionUser;

    // Allow access if we are an admin for essential
    // And if there is a chart key
    const { chartKey } = useParams<RouteParams>();
    const hasEssential = useIsEssential();
    if (hasEssential) {
        if (chartKey && isAdminUser) {
            allowed = true;
        } else {
            allowed = false;
        }
    }

    if (isSupportUser) return <>{children}</>;
    return (
        <ModuleWithCallToAction
            hasModule={hasDecision}
            redirectionUrl={routes.decisionCta}
        >
            {allowed ? (
                <>{children}</>
            ) : (
                <ModuleForbidden title={t('moduleForbidden.page')} />
            )}
        </ModuleWithCallToAction>
    );
};

export default ExploreWithAccessCheck;
